import React, { useMemo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { compareBigNumbers, sumFixedDecimals } from '@/shared/utils/helpers';
import { useModal } from '@/components/Modals/ModalWrapperHooks';
/*In case of custom logic made override for WithdrawalInput here*/
import { WithdrawalInput } from '@/widgets/Modals';

type WithdrawalInputProps = {
    value: string;
    name: string;
    setValue: (value: string | null) => void;
    tokenSymbol: string;
    poolBalance: string;
    disabled?: boolean;
    decimals: number;
    interestClaimable: string;
    totalPosition: string;
    interestAccrued: string;
};

export const WithdrawalAmountField = ({ name }: { name: string }) => {
    const { control } = useFormContext();
    const { modalProps } = useModal();

    const {
        tokenSymbol,
        decimals,
        interestClaimable,
        totalPosition,
        interestAccrued,
        poolBalance,
    } = modalProps || {};

    const maxBalance = useMemo(() => {
        const due = sumFixedDecimals(totalPosition!, interestAccrued!, decimals);
        return compareBigNumbers(due, poolBalance, decimals) === 1 ? poolBalance : due;
    }, [totalPosition, interestAccrued, decimals, poolBalance]);

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <WithdrawalInput<WithdrawalInputProps>
                    {...field}
                    setValue={(value) => field.onChange(value)}
                    tokenSymbol={tokenSymbol}
                    poolBalance={poolBalance}
                    decimals={decimals}
                    interestClaimable={interestClaimable}
                    totalPosition={totalPosition}
                    interestAccrued={interestAccrued}
                    disabled={Number(poolBalance) === 0}
                    maxBalance={maxBalance}
                />
            )}
        />
    );
};
